import { api_GET, api_POST, api_PUT, api_DELETE } from './_api';

const assinatura_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Assinatura/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Assinatura/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Assinatura`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Assinatura`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default assinatura_api;